import React, { useState } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTelegram,
  FaArrowUp,
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import "./Footer.css";
import logo2 from "../../assets/imgs/logo2.png";

const Footer = () => {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  window.addEventListener("scroll", checkScrollTop);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Logo and Info Section */}
          <div className="footer-section">
            <div className="footer-logo">
              <img className="footer_logo_img" src={logo2}></img>
            </div>
            <p className="footer-description">
              Eskista Rentals is spaces for photographers, filmmakers, and
              content creators. State-of-the-art facilities with professional
              equipment.
            </p>
            <div className="footer-address">
              <p>DH Geda Tower, Bole Addis Ababa</p>
              <p>Phone: +251 911 465 364</p>
              <p>Email: info@eskista.com</p>
              <p>Email: eskistaethiopia@gmail.com</p>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <a href="#" className="footer-link">
                  Home
                </a>
              </li>
              <li>
                <a href="#about-section" className="footer-link">
                  About Us
                </a>
              </li>
              <li>
                <a href="#gear-section" className="footer-link">
                  Gears
                </a>
              </li>
              <li>
                <a href="#video-studios-section" className="footer-link">
                  Studio
                </a>
              </li>
              <li>
                <a href="#testimonial-section" className="footer-link">
                  Testimonial
                </a>
              </li>
              <li>
                <a href="#contact" className="footer-link">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div className="footer-section">
            <h3 className="footer-heading">Connect With Us</h3>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/eskistarental"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.instagram.com/eskistarental"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/eskistarental/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://www.tiktok.com/@eskistarental"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <SiTiktok />
              </a>
              <a
                href="https://t.me/eskistarental"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Telegram"
              >
                <FaTelegram />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="copyright">
          <p>
            &copy; {new Date().getFullYear()} Studio Rentals. All rights
            reserved.
          </p>
          {/* <div className="legal-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/cookies">Cookie Policy</a>
          </div> */}
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        className={`scroll-to-top ${showScroll ? "show" : ""}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <FaArrowUp />
      </button>
    </footer>
  );
};

export default Footer;
